import { Injectable } from '@angular/core';
import { CentralService } from '../central.service';

@Injectable({
  providedIn: 'root'
})

export class CompaniesService extends CentralService {

  protected resource: string = "companies";

}
